module.exports = __webpack_public_path__ + "static/media/squiggle.7f58ad75.svg";